import { Currency } from '@/core/currency/interfaces';

const LSL: Currency = {
    name: 'Lesotho Loti',
    demonym: 'Lesotho',
    majorSingle: 'Loti',
    majorPlural: 'maLoti',
    codeNumeric: '426',
    symbol: 'L',
    symbolNative: 'L',
    minorSingle: 'Sente',
    minorPlural: 'Lisente',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'LSL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default LSL;
